// extracted by mini-css-extract-plugin
export default {"lang":"lang-switcher_lang__WpwO"};